/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component} from '@angular/core';

import {CommunicationsService} from '../communications.service';

@Component({
  selector: 'gp-communications-card',
  templateUrl: './communications-card-component.html',
  styleUrls: ['../../information/notifications-general.styles.scss']
})
export class CommunicationsCardComponent {

  constructor(
    public communicationsService: CommunicationsService
  ) {
  }
}
